import DefaultProps from '../../commonTypes/defaultprops.types';
import { ReactElement } from 'react';
import Handler from '../../commonTypes/handler.types';
import { SortOrderTypes } from '../DataTable/dataTable.types';

export interface ColumnsState {
  [key: string]: {
    sortable?: boolean;
    sortState?: SortOrderTypes;
    type?: TableDataTypes;
    sortColumns?: SortColumn[];
    dataField?: string;
    sortField?: string;
  };
}

export interface TableProps extends DefaultProps {
  thead: TheadType[];
  tbody?: BodyFootProps[];
  tbodies?: BodyFootProps[][];
  tfoot?: BodyFootProps[];
  width?: string;
  maxWidth?: string;
  tableFixed?: boolean;
  customCells?: CustomCellsProps[];
  startRight?: boolean;
  bodyTdPadding?: string;
  bodyThPadding?: string;
  headThPadding?: string;
  hideDividers?: boolean;
  highlightedCells?: CellHighlights[];
  highlightHead?: boolean;
  hoverRowHighlight?: boolean;
  cellHighlightColor?: string;
  // DATA TABLE USE
  headerHandlers?: Handler;
  columnsState?: ColumnsState;
  columnSortIndex?: number;
  highlightSortedColumn?: boolean;
  tableRowHandlers?: Handler;
  selectedRowIndex?: number | number[][];
  underlinedRowIndex?: number | number[][];
  replaceCustomCellWithSkeleton?: boolean;
  tableHandlers?: Handler;
  underlinedRowColor?: string;
}

export enum TableDataTypes {
  STRING = 'string',
  NUMBER = 'number',
  DATE = 'date',
  BOOLEAN = 'boolean',
}

// Head Types/Props
export interface HeadProps {
  content?: ContentTypes;
  pinned?: boolean;
  fixedWidth?: string;
  dataField?: string;
  alignment?: Alignments;
  placeholder?: string;
  highlighted?: boolean;
  // INTERNAL USE
  colgroupStart?: boolean;
  colgroupEnd?: boolean;
  hasSuperHeader?: boolean;
  colgroupSpan?: number;
  // DATA TABLE USE
  sortField?: string;
  type?: TableDataTypes;
  sortable?: boolean;
  initialSort?: boolean;
  sortColumns?: SortColumn[];
  sortState?: SortOrderTypes;
}
// Props for each column group head object
export interface GroupHeadProps {
  groupTitle?: string;
  groupColumns: HeadProps[];
}
// Props to fill the thead array in TableProps
export type TheadType = HeadProps | GroupHeadProps;

// What content can be
export type ContentTypes = string | number | ReactElement;

//What the body and foot data can be comprised of
export interface BodyFootProps {
  [property: string]: ContentTypes;
}

// Alignments for each column
export enum Alignments {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}

// Custom cells to use for each celltype+datafield pairing
export interface CustomCellsProps {
  cellType: CellTypes;
  customCell: ReactElement;
  dataField: string;
}

// INTERNAL USE
export enum CellTypes {
  SUPER_HEADER = 'super-header',
  HEADER = 'header',
  BODY = 'body',
  FOOTER = 'footer',
}

export interface CellHighlights {
  dataField: string;
  rowIndex: number;
}

export interface SortColumn {
  columnIndex: number;
  sortOrder: SortOrderTypes;
}
